export const GET_SURVEY_ACTION = 'GET_SURVEY_ACTION';
export const GET_EXPIRED_DT_ACTION = 'GET_EXPIRED_DT_ACTION';
export const POST_SURVEY_ACTION = 'POST_SURVEY_ACTION';
export const UPDATE_SURVEY_ACTION = 'UPDATE_SURVEY_ACTION';
export const GET_BYEONJUENG_RESULT_ACTION = 'GET_BYEONJUENG_RESULT_ACTION';
export const SUBMIT_SURVEY_ACTION = 'SUBMIT_SURVEY_ACTION';
